module.exports = __webpack_public_path__ + "img/cooperation01.e3b58795.png";